globalThis.backoffice = globalThis.backoffice || {};

globalThis.unsubscriptionRequestForm = function() {
    var $unsubscriptionRequestForm = $(".panel#unsubscription-request-form");
    var $selectUnsubscriptionReason = $unsubscriptionRequestForm.find("#unsubscription-request-unsubscription-reason .select");
    var $selectUnsubscriptionRequestMainQualifications = $unsubscriptionRequestForm.find(".unsubscription-request-main-qualifications");

    $selectUnsubscriptionReason.on("change", function() {
        var $this = $(this),
            val = $this.val();

        $selectUnsubscriptionRequestMainQualifications.hide();
        $unsubscriptionRequestForm.find(`#unsubscription-request-${val}-fieldset`).fadeIn();
    });

    var $missing_feature_inputs = $unsubscriptionRequestForm.find("#missing_features_booleans input");
    var $missing_feature_other_input = $unsubscriptionRequestForm.find('input[name="business_services_website_agency_unsubscription_request[qualification_attributes][missing_feature_other]"]');
    var $missing_feature_other_description = $unsubscriptionRequestForm.find("#missing_feature_other_description");
    $missing_feature_inputs.on("change", function() {
        if($missing_feature_other_input.is(":checked")) {
            $missing_feature_other_description.fadeIn();
        } else {
            $missing_feature_other_description.fadeOut();
        }
    });

    var $better_design_inputs = $unsubscriptionRequestForm.find("#better_design_booleans input");
    var $better_design_other_input = $unsubscriptionRequestForm.find('input[name="business_services_website_agency_unsubscription_request[qualification_attributes][better_design_other]"]');
    var $better_design_other_description = $unsubscriptionRequestForm.find("#better_design_other_description");
    $better_design_inputs.on("change", function() {
        if($better_design_other_input.is(":checked")) {
            $better_design_other_description.fadeIn();
        } else {
            $better_design_other_description.fadeOut();
        }
    });

    $no_time_for_website_inputs = $unsubscriptionRequestForm.find("#no_time_for_website input");
    $no_time_for_website_other_input = $unsubscriptionRequestForm.find('input[name="business_services_website_agency_unsubscription_request[qualification_attributes][no_time_for_website_other]"]');
    $no_time_for_website_other_description = $unsubscriptionRequestForm.find("#no_time_for_website_other_description");
    $no_time_for_website_inputs.on("change", function() {
        if($no_time_for_website_other_input.is(":checked")) {
            $no_time_for_website_other_description.fadeIn();
        } else {
            $no_time_for_website_other_description.fadeOut();
        }
    });

    var $disappointing_service_inputs = $unsubscriptionRequestForm.find("#disappointing_service input");
    var $disappointing_service_other_input = $unsubscriptionRequestForm.find('input[name="business_services_website_agency_unsubscription_request[qualification_attributes][disappointing_service_other]"],input[name="business_services_local_management_agency_unsubscription_request[qualification_attributes][disappointing_service_other]"],input[name="business_services_location_agency_unsubscription_request[qualification_attributes][disappointing_service_other]"]');
    var $disappointing_service_other_description = $unsubscriptionRequestForm.find("#disappointing_service_other_description");
    $disappointing_service_inputs.on("change", function() {
        if($disappointing_service_other_input.is(":checked")) {
            $disappointing_service_other_description.fadeIn();
        } else {
            $disappointing_service_other_description.fadeOut();
        }
    });

    $activity_stopped_type_select = $unsubscriptionRequestForm.find("#activity_stopped_type select");
    $postponed_project_type = $unsubscriptionRequestForm.find("#postponed_project_type");
    $activity_stopped_type_select.on("change", function() {
        $(this).val() == "postponed_project" ? $postponed_project_type.fadeIn() : $postponed_project_type.fadeOut()
    });

    $provider_change_inputs = $unsubscriptionRequestForm.find("#provider_change input");
    $provider_change_name = $unsubscriptionRequestForm.find("#provider_change_name");
    $provider_change_inputs.on("change", function() {
        if(["agency", "self_service_tool"].includes($(this).val())) {
            $provider_change_name.fadeIn();
        } else {
            $provider_change_name.fadeOut();
        }
    });
}

unsubscriptionRequestForm();
